<!-- Custom loading overlay -->
<div *ngIf="isLoading" class="loading-overlay">
  <div class="loading-content">
    <!-- Spinning Clock -->
    <div class="clock">
      <div class="clock-face">
        <div class="hour-hand"></div>
        <div class="minute-hand"></div>
      </div>
    </div>

    <!-- Animated GIF -->
    <div [innerHTML]="currentGif" class="loading-gif"></div>

    <!-- Message -->
    <p class="loading-message">{{ currentMessage }}</p>
  </div>
</div>
<div class="container">


  <h1><img src="assets/img/askGramperly-medium.jpg" alt="Ask Gramperly Logo" height="150">Ask Gramperly</h1>

  <div class="row">
    <div class="col-12">
      <div class="input-group w-75">
        <span class="input-group-text" id="basic-addon1">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"></path>
          </svg>
        </span>
        <input (keyup.enter)="onSubmit()" type="text" class="form-control" (input)="onUpdateQuestion($event)" placeholder="Enter your question, sonny." >
        <button (click)="onSubmit()" type="submit" class="btn btn-primary">Ask away</button>
      </div>
      <div class="high-gear-option">
        <label>
          <input type="checkbox" [(ngModel)]="highGear"> Get Gramp into high gear!
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <br/><br/>
    </div>
  </div>

  <!-- Search Results -->
  <div *ngIf="showResults" class="row">
    <div class="col-12">
      <p class="search-time-message">
        Found {{ searchResults.length }} result{{ searchResults.length !== 1 ? 's' : '' }}
        ({{ lastRandomLoadingTimeInSeconds() | number:'1.0-0' }} seconds - what's your hurry?)
      </p>

      <!-- Error state -->
      <div *ngIf="searchError" class="alert alert-warning">
        <p>My memory isn't what it used to be... couldn't find anything. Try again later, sonny.</p>
      </div>

      <!-- Results list -->
      <div *ngIf="searchResults.length > 0" class="search-results">
        <div *ngFor="let result of searchResults" class="search-result-item">
          <div class="result-domain">{{ getDomainFromUrl(result.url) }}</div>
          <a [href]="result.url" target="_blank" rel="noopener noreferrer" class="result-title">
            {{ result.title }}
          </a>
          <p class="result-description">{{ result.description }}</p>
        </div>
      </div>

      <!-- No results state -->
      <div *ngIf="searchResults.length === 0 && !searchError" class="no-results">
        <p>My mind is not as sharp as it once was. No results found.</p>
      </div>

      <br/>
      <h3>People also ask:</h3>
      <p *ngFor="let question of gramperlyQuestions">{{ question }}</p>
    </div>
  </div>
</div>



